<template>
    <div
        class="text-base-14 lg:text-base-16 lg: mx-auto max-w-[1000px] self-center px-4 py-8 md:px-8 lg:p-12">
        <h1 class="text-center font-bold leading-10">
            СОГЛАСИЕ<br />
            субъекта персональных данных на обработку, хранение персональных данных и
            автоматизированную обработку персональных данных
        </h1>

        <p class="mt-4 inline-block w-52 border-b border-surface-800 text-center">дата</p>

        <p class="mt-4">
            В соответствии с Федеральным законом от&nbsp;27.07.2006&nbsp;г. №&nbsp;152-ФЗ
            «О&nbsp;персональных данных» Я,
            <span class="mt-4 inline-block w-36 border-b border-surface-800 text-center" />
            <span class="mt-4 inline-block w-[99%] border-b border-surface-800 text-center">
                ФИО </span
            >, паспорт серия
            <span class="mt-4 inline-block w-72 border-b border-surface-800 text-center">
                серия&nbsp;и&nbsp;номер </span
            >, выдан
            <span class="mt-4 inline-block w-[430px] border-b border-surface-800 text-center">
                орган&nbsp;выдачи
            </span>
            <span class="mt-4 inline-block w-80 border-b border-surface-800 text-center" />
            дата выдачи:
            <span class="mt-4 inline-block w-44 border-b border-surface-800 text-center">
                дата&nbsp;выдачи </span
            ><br />
            Зарегистрированный(ая) по адресу:
            <span class="mt-4 inline-block w-[99%] border-b border-surface-800 text-center">
                адрес&nbsp;регистрации
            </span>
        </p>
        <p class="mt-6">
            Действуя свободно, своей волей и в своем интересе, а также подтверждая свою
            дееспособность, даю свое согласие ООО&nbsp;ПКО&nbsp;«ХАБЕР», Юридический адрес: 125212,
            г.&nbsp;Москва, Кронштадтский бульвар, д.&nbsp;7А, стр.&nbsp;1, помещение&nbsp;I,
            ОГРН:&nbsp;1187746377411 ИНН:&nbsp;7743250388 КПП:&nbsp;774301001, (далее – Оператор),
            на обработку своих персональных данных со следующими условиями:
        </p>
        <ol>
            <li class="mt-2 list-decimal">
                Настоящее согласие дается на обработку персональных данных, как без использования
                средств автоматизации, так и с их использованием.
            </li>
            <li class="mt-2 list-decimal">
                Настоящее согласие дается на обработку следующих моих персональных данных: номер
                мобильного телефона, фамилия, имя, отчество, адрес электронной почты, дата рождения,
                место рождения, реквизиты документа, удостоверяющего личность.
            </li>
            <li class="mt-2 list-decimal">
                Настоящим подтверждаю принадлежность мне мобильного номера телефона, введенного на
                сайте Оператора.
            </li>
            <li class="mt-2 list-decimal">
                Цель обработки персональных данных: создание учетной записи на сайте Оператора, с
                моими персональными данными, а именно: номер мобильного телефона, фамилия, имя,
                отчество; участие в маркетинговых и рекламных акциях; ответ физическим лицам,
                обратившимся через форму обратной связи; публикация отзыва на сайте Оператора;
                предоставление мне информации об оказываемых Оператором услугах, предоставление
                Оператором консультационных услуг, в том числе в целях заключения мной в дальнейшем
                договоров/соглашений, в том числе с использованием сетей электросвязи, в том числе
                подвижной радиотелефонной связи, рассылка по адресу, электронной почты;
                осуществление проверки достоверности и полноты предоставленной информации; для
                осуществления прав и законных интересов оператора или третьих лиц, в том числе в
                случаях, предусмотренных Федеральным законом от&nbsp;03.07.2016 №230-ФЗ
                "О&nbsp;защите прав и законных интересов физических лиц при осуществлении
                деятельности по возврату просроченной задолженности и о внесении изменений в
                Федеральный закон "О&nbsp;микрофинансовой деятельности и микрофинансовых
                организациях"; обработка и (или) прием и регистрация обращений, жалоб, заявлений,
                полученных по адресу электронной почты Оператора, а&nbsp;также посредством Почты
                России по почтовому адресу Оператора; взыскание задолженности в досудебном и/или
                судебном порядке.
            </li>
            <li class="mt-2 list-decimal">
                Оператор осуществляет сбор, запись, систематизацию, накопление, хранение,
                извлечение, уточнение (обновление, изменение), передачу (предоставление, доступ),
                блокирование, удаление и уничтожение
            </li>
        </ol>
    </div>
</template>
